import Vue from 'vue';
import TYPES from '@/types';

// Application
import CustomerBankAccountChooseYourDocumentsService
  from '@/modules/user/customer-bank-account/application/services/customer-bank-account-choose-your-documents-service';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { Values } from '@/modules/shared/domain/i18n/types';
import Translator from '@/modules/shared/domain/i18n/translator';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class UpdateBankAccountModalViewModel {
  @Inject(TYPES.CUSTOMER_BANK_ACCOUNT_CHOOSE_YOUR_DOCUMENTS_SERVICE)
  private readonly choose_your_documents_service!: CustomerBankAccountChooseYourDocumentsService;

  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.user-profile.user-profile-tabs.user-profile-my-documents-tab.update-bank-account.bank-account-modal';

  readonly STEPS = [
    'UpdateBankAccountChooseYourDocuments',
    'UpdateBankAccountData',
  ];

  current_step = 0;

  current_component = this.STEPS[this.current_step];

  private readonly view!: Vue;

  public constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  nextStep = async () => {
    if (this.current_step < this.STEPS.length) {
      this.current_step += 1;
      this.current_component = this.STEPS[this.current_step];
    }
  }

  prevStep = () => {
    if (this.current_step > 0) {
      this.current_step -= 1;
      this.current_component = this.STEPS[this.current_step];
    }
  }

  getActiveClass = (index: number, is_title: boolean) => {
    const inactive_class = 'dark-grey';
    const active_class = 'secondary';
    if (is_title) {
      if (this.current_step >= index) {
        return active_class;
      }
      return inactive_class;
    }
    if (index < this.current_step) {
      return active_class;
    }
    return inactive_class;
  }

  clearState = () => {
    this.choose_your_documents_service.setChooseYourDocumentsData({
      wealth_option_is_checked: false,
      pocket_option_is_checked: false,
      selected_investment_product_ids: [],
    });
  }
}
